export class Fidc {
  public id!: number | string | null;
  public nome!: string;
  public cnpj!: string;
  public banco!: string;
  public agencia!: string;
  public conta!: string;
  tipoContrato: string | null = null;
  afne: number = 0;
  ca: number | null = null;
}